export default "__VITE_ASSET__D$UVSMZG__"